import { http } from './http.service';
import { AddProduct, Product } from '@/types/quick-order';

class QuickOrderService {
  getProductByCatalogId = async (catalogNumber: string) => {
    const response = await http.post<Product[]>(`api/quickOrder/search/product`, {
      catalogNumber,
    });
    return response;
  };
  addBatchToCart = async (products: AddProduct[]) => {
    const response = await http.post(`/api/cart/batch/add`, { batchAddItems: products });
    return response;
  };
  uploadQuickOrder = async (file) => {
    const formData = new FormData();
    formData.append('file', file);
    const response = await http.fileUpload('api/quickOrder/upload', formData);
    return response;
  };
}
export const quickOrderService = new QuickOrderService();
